import {
  FREE_TRIAL_PRICE_MAD,
  PAYG_MAX_GENERATIONS,
  PAYG_MIN_GENERATIONS,
  PAYG_PRICE_PER_GEN_MAD,
  PRO_SEMESTER_MAD,
  PRO_YEARLY_MAD,
  SEMESTER_WEEKS,
  STARTER_SEMESTER_MAD,
  STARTER_YEARLY_MAD,
  YEARLY_WEEKS,
  paygTotalMad,
  subscriptionPriceMad,
  yearlySavingsMad,
} from "../../shared/pricing";

export {
  FREE_TRIAL_PRICE_MAD,
  PAYG_MAX_GENERATIONS,
  PAYG_MIN_GENERATIONS,
  PAYG_PRICE_PER_GEN_MAD,
  PRO_SEMESTER_MAD,
  PRO_YEARLY_MAD,
  SEMESTER_WEEKS,
  STARTER_SEMESTER_MAD,
  STARTER_YEARLY_MAD,
  YEARLY_WEEKS,
  paygTotalMad,
  subscriptionPriceMad,
  yearlySavingsMad,
};

export type BillingCycleMarketing = "semester" | "yearly";

export function subscriptionFeeMadMarketing(
  plan: "starter" | "pro",
  cycle: BillingCycleMarketing,
): number {
  if (plan === "starter") {
    return cycle === "semester" ? STARTER_SEMESTER_MAD : STARTER_YEARLY_MAD;
  }
  return cycle === "semester" ? PRO_SEMESTER_MAD : PRO_YEARLY_MAD;
}

export function subscriptionWeeklyMadEquivalent(
  mad: number,
  weeks: number,
): number {
  return Math.round((mad / weeks) * 10) / 10;
}

export function yearlySavingsVersusSemesterPace(
  semesterPriceMad: number,
  yearlyPriceMad: number,
): number {
  return Math.max(0, semesterPriceMad * 2 - yearlyPriceMad);
}

export function paygTotalMadMarketing(generations: number): number {
  return paygTotalMad(generations);
}
